export enum ClaimEntryKind {
  Issue = 'ISSUE',
  Item = 'ITEM',
  Property = 'PROPERTY',
}
